import i18n from "../../../i18n";
import { Notification } from "../../../Utils/Notification";

export const changePolygon = (state, action) => {
  const updateValue = JSON.parse(JSON.stringify(state.ChangedPolygons));

  if (action.state === "add") {
    updateValue[action.key] = [...state.ChangedPolygons[action.key], action.value]; // note - value is just polygon id not array of polygon id

    if (action.key !== 'TotalChangedPolygons') { // add polygon id to TotalChangedPolygons
      const idIsExist = updateValue["TotalChangedPolygons"].find(id => id === action.value);
      if (!Boolean(idIsExist)) {
        updateValue.TotalChangedPolygons = [...updateValue.TotalChangedPolygons, action.value];
      };
    };
  };

  if (action.state === "remove") {
    const allIds = state.ChangedPolygons[action.key];
    const idx = allIds.findIndex(id => id === action.value);
    if (idx !== -1) {
      allIds.splice(idx, 1);
    };

    updateValue[action.key] = allIds;

    if (action.key !== 'TotalChangedPolygons') { // add polygon id to TotalChangedPolygons
      let idIsExistInAnotherCH = false;
      Object.keys(updateValue).forEach(CH => {
        if (CH !== 'TotalChangedPolygons') {
          const idIsExist = updateValue[CH].find(id => id === action.value);
          if (idIsExist) {
            idIsExistInAnotherCH = true;
          };
        }
      });

      if (!idIsExistInAnotherCH) {
        const idx = updateValue.TotalChangedPolygons.findIndex(id => id === action.value);
        updateValue.TotalChangedPolygons.splice(idx, 1);
      }
    };
  };

  return { ...state, ChangedPolygons: updateValue };
};

export const updatePolygonSetting = (state, action) => {
  if (action.key === "isShowOnlyNoDriverPolygons") {
    // dedicated action SET_SHOW_ONLY_NO_DRIVER_POLYGONS is the only writer for this flag
    return state;
  }
  if (action.value === state.PolygonSetting[action.key]) {
    return state;
  }
  const updateValue = {
    ...state.PolygonSetting,
    [action.key]: action.value,
  };
  return { ...state, PolygonSetting: updateValue };
};

export const setShowOnlyNoDriverPolygons = (state, action) => {
  if (action.value === state.PolygonSetting.isShowOnlyNoDriverPolygons) {
    return state;
  }
  return {
    ...state,
    PolygonSetting: {
      ...state.PolygonSetting,
      isShowOnlyNoDriverPolygons: action.value,
    },
  };
};

export const updatePolygonsList = (state, action) => {
  const updateValue = {
    ...state.FilteredPolygons,
    [action.key]: action.value,
  };
  return { ...state, FilteredPolygons: updateValue };
};

const handleRequestVehicle = (updateMainPlanData, state, action) => {
  const { polygon } = action; // the polygon

  if (Boolean(polygon.subPlan.driverInfo)) {
    Notification.pushNotif(i18n.t("Notification.reqVehicle_HasDriver"), "error")
    return state.PolygonSetting.RequestVehiclePolygons;
  };

  let RequestVehicle = [];
  try {
    RequestVehicle = [...state.PolygonSetting.RequestVehiclePolygons]; // list of polygons with request vehicle
  } catch (error) {
    RequestVehicle = [];
  }

  const { PlanInfo, mainPlanData } = state;
  const InRequestMode = RequestVehicle.findIndex(uid => uid === polygon.subPlan.uid);

  if (
    InRequestMode === -1 &&
    state.cantDoEditAfterGetExternal &&
    polygon?.sentByGetExternal
  ) {
    Notification.pushNotif(
      i18n.t("Notification.CantEditAfterGetExternal"),
      "warning"
    );
    return RequestVehicle;
  }

  if (InRequestMode !== -1) { // if polygon was selected before this
    const mainPoly = PlanInfo.response.data.polygons.find(poly => poly.subPlan.uid === polygon.subPlan.uid);
    const newMainPlanData = mainPlanData.polygons.map(poly => { // change polygon color Id to normal
      if (poly.subPlan.uid === polygon.subPlan.uid) {
        poly.colorId = mainPoly.colorId;
        action.polygon.colorId = mainPoly.colorId;
      }
      return poly;
    });
    updateMainPlanData.polygons = newMainPlanData;
    RequestVehicle.splice(InRequestMode, 1); // remove polygon id from state
    return RequestVehicle;
  } else {
    const newMainPlanData = mainPlanData.polygons.map(poly => { // set white color to polygon
      if (poly.subPlan.uid === polygon.subPlan.uid) {
        poly.colorId = "#00d4ff";
        action.polygon.colorId = "#00d4ff";
      }
      return poly;
    });
    updateMainPlanData.polygons = newMainPlanData;
    RequestVehicle.push(polygon.subPlan.uid); // add polygon uid to requestVehicle field in PolygonSetting
    return RequestVehicle;
  };
};

const handleMerge = (updateMainPlanData, state, action) => {
  const { polygon } = action; // the polygon

  if (Boolean(polygon.subPlan.driverInfo)) {
    Notification.pushNotif(i18n.t("Notification.Merge_HasDriver"), "error")
    return state.PolygonSetting.MergePolygons;
  };

  let MergePolygons = [];
  try {
    MergePolygons = [...state.PolygonSetting.MergePolygons]; // list of polygons should be merged
  } catch (error) {
    MergePolygons = [];
  }

  const { PlanInfo, mainPlanData } = state;
  const InMergeMode = MergePolygons.findIndex(uid => uid === polygon.subPlan.uid);

  if (
    InMergeMode === -1 &&
    state.cantDoEditAfterGetExternal &&
    polygon?.sentByGetExternal
  ) {
    Notification.pushNotif(
      i18n.t("Notification.CantEditAfterGetExternal"),
      "warning"
    );
    return MergePolygons;
  }

  if (InMergeMode !== -1) { // if polygon was selected to merge before this
    const mainPoly = PlanInfo.response.data.polygons.find(poly => poly.subPlan.uid === polygon.subPlan.uid);
    const newMainPlanData = mainPlanData.polygons.map(poly => { // change polygon color Id to normal
      if (poly.subPlan.uid === polygon.subPlan.uid) {
        poly.colorId = mainPoly.colorId;
        action.polygon.colorId = mainPoly.colorId;
      }
      return poly;
    });
    updateMainPlanData.polygons = newMainPlanData;
    MergePolygons.splice(InMergeMode, 1); // remove polygon id from MergePolygons list
    return MergePolygons;
  } else {
    const newMainPlanData = mainPlanData.polygons.map(poly => { // set white color to polygon
      if (poly.subPlan.uid === polygon.subPlan.uid) {
        poly.colorId = "#00d4ff";
        action.polygon.colorId = "#00d4ff";
      }
      return poly;
    });
    updateMainPlanData.polygons = newMainPlanData;
    MergePolygons.push(polygon.subPlan.uid); // add polygon uid to MergePolygons field in PolygonSetting
    return MergePolygons;
  };
};

export const selectPolygon = (state, action) => {

  // const JustShowPolygonPin = state.MenuItems.polygonPins === 2;

  const mapDrawerTab = state.PinSetting.AssignRemainPin?.length ? 1 : 3

  const updatePolygon = { ...state.MapItems, selectedPolygon: action.polygon };
  const updateMenuItem = { ...state.MenuItems, drawer: true, polygonPins: state.MenuItems.polygonPins === 0 ? 1 : state.MenuItems.polygonPins, };
  const updatePinSetting = {
    ...state.PinSetting,
    // showListOfPolygonPins: JustShowPolygonPin ? true : state.PinSetting.showListOfPolygonPins
  };
  const updatePolygonSetting = { ...state.PolygonSetting, showListOfPolygons: false };
  const updateMainPlanData = { ...state.mainPlanData };

  if (state.MenuItems.requestVehicle) { // in request vehicle mode
    action.shouldUpdate = true;
    updatePolygonSetting.RequestVehiclePolygons = handleRequestVehicle(updateMainPlanData, state, action)
  }

  if (state.MenuItems.merge) { // in merge polygons mode
    action.shouldUpdate = true;
    updatePolygonSetting.MergePolygons = handleMerge(updateMainPlanData, state, action)
  };

  if (!!state.MapItems.selectedPolygon?.subPlan && !action.shouldUpdate) { // if update select polygon is not forced
    if (action.polygon?.subPlan?.uid === state.MapItems.selectedPolygon?.subPlan?.uid) { // dont select selectedPolygon again

      return {
        ...state,
        planViewMapDrawerTab: 3,
        // JustShowPolygonPin ? state.planViewMapDrawerTab : 3,
        PinSetting: {
          ...state.PinSetting,
          // showListOfPolygonPins: JustShowPolygonPin ? true : state.PinSetting.showListOfPolygonPins
        },
        MenuItems: { ...state.MenuItems, drawer: true },
        PolygonSetting: { ...state.PolygonSetting, showListOfPolygons: false },
      };
    };
  };

  return {
    ...state,
    MapItems: updatePolygon,
    MenuItems: updateMenuItem,
    PinSetting: updatePinSetting,
    mainPlanData: updateMainPlanData,
    planViewMapDrawerTab: mapDrawerTab,
    PolygonSetting: updatePolygonSetting,
  };
};
